type DocsListener = () => void;

const listeners = new Set<DocsListener>();
let flushQueued = false;

/** Notify UI that invoice/quote cache data changed (status, schedule, etc.). */
export function notifyDocsChanged() {
  if (flushQueued) return;
  flushQueued = true;
  queueMicrotask(() => {
    flushQueued = false;
    for (const fn of [...listeners]) {
      try {
        fn();
      } catch {
        /* listener errors must not break others */
      }
    }
  });
}

/** Subscribe to doc cache changes. Returns unsubscribe. */
export function onDocsChanged(fn: DocsListener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
